import api from '@pray/shared/utils/api';

export type GetProductMetricsGridParams = {
  artistId: string;
  referenceDate?: string | null;
  platform?: string | null;
  countryTier?: string | null;
  subStatus?: string | null;
  isRegistered?: string | null;
  bustCache?: boolean;
};

export const getProductMetricsGrid = async ({
  artistId,
  referenceDate = null,
  platform = null,
  countryTier = null,
  subStatus = null,
  isRegistered = null,
  bustCache = false,
}: GetProductMetricsGridParams) => {
  const params: Record<string, string> = {};

  if (referenceDate) params.referenceDate = referenceDate;
  if (platform && platform !== 'all') params.platform = platform;
  if (countryTier && countryTier !== 'all') params.countryTier = countryTier;
  if (subStatus && subStatus !== 'all') params.subStatus = subStatus;
  if (isRegistered && isRegistered !== 'all') params.isRegistered = isRegistered;
  if (bustCache) params.bustCache = 'true';

  const url = `/web/studio/artists/${artistId}/analytics/product-metrics`;
  const response = await api.executeGetRequest(url, params);

  return (response.data as any)?.data?.data;
};
